import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=3254d9be&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"
import style0 from "./Chat.vue?vue&type=style&index=0&id=3254d9be&prod&lang=scss&scoped=true"
import style1 from "./Chat.vue?vue&type=style&index=1&id=3254d9be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3254d9be",
  null
  
)

export default component.exports